const System = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <h1 className="text-3xl font-bold mb-4">Settings System</h1>
        </div>
    );
}
 
export default System;